// extracted by mini-css-extract-plugin
export var awardsContainer = "ProjectAwards-module--awardsContainer--5d30e";
export var headingStyle = "ProjectAwards-module--headingStyle--b5d71";